<template>
    <div class="scc-embed-element" v-html="html"></div>
</template>

<script>
import './embed-element.scss';

export default {
    name: 'EmbedElement',
    __editor: {
        fields: {
            embed: {
                widget: 'textarea',
            },
        },
    },
    props: {
        embed: String,
    },
    computed: {
        html() {
            if (this.embed) {
                return this.$sanitize(this.embed);
            }

            return null;
        },
    },
};
</script>
